/* eslint-disable @typescript-eslint/camelcase */
const dotenvVars = require('dotenv-flow').config({
  node_env: process.env.APP_ENV,
  default_node_env: 'development'
}).parsed;
// // eslint-disable-next-line no-console
// console.info('APP_ENV', process.env.APP_ENV);
// // eslint-disable-next-line no-console
// console.info('NODE_ENV', process.env.NODE_ENV);

const packageJson = require('../package.json');

const BAKED_IN_ENV_VARS = [
  'NODE_ENV',
  'PUBLIC_URL',
  'VERSION',
  'CABS_FQDN',
  'PLACES_AUTOCOMPLETE_URL',
  'LOCATION_FETCH_URL',
  'AIRPORT_AUTOCOMPLETE_URL',
  'OFFERS_URL',
  'FETCH_LOCATION_URL_V3',
  'AUTOCOMPLETE_URL_V3',
  'PAGE_FETCHER_URL'
];

function getAppEnv() {
  const raw = Object.keys(dotenvVars || {}).reduce(
    (env, key) => {
      env[key] = process.env[key];
      return env;
    },
    {
      NODE_ENV: process.env.NODE_ENV,
      PUBLIC_URL: process.env.PUBLIC_URL,
      VERSION: packageJson.version
    }
  );

  const forWebpackDefinePlugin = {
    'process.env': Object.keys(raw).reduce((env, key) => {
      if (BAKED_IN_ENV_VARS.includes(key)) {
        env[key] = JSON.stringify(raw[key]);
      }
      return env;
    }, {})
  };

  const forIndexHtml = JSON.stringify({
    env: raw
  });

  return { raw, forIndexHtml, forWebpackDefinePlugin };
}

module.exports = {
  getAppEnv
};
